/**
 * Descripción de una institución
 * @export
 * @interface Institucion
 */
export interface IInstitucion {
  /**
   * Identificador único
   * @type {number}
   * @memberof Institucion
   */
  id?: number;
  /**
   * Clave de la institución, puede ser nula en algunos casos
   * @type {string}
   * @memberof Institucion
   */
  clave?: string;
  /**
   * Nombre de la institución
   * @type {string}
   * @memberof Institucion
   */
  nombre?: string;
  /**
   * Tipo de institución
   * @type {BaseCatalogo}
   * @memberof Institucion
   */
  tipo?: BaseCatalogo;
  /**
   * País de la institución de acuerdo a catálogo
   * @type {BaseCatalogo}
   * @memberof Institucion
   */
  pais?: BaseCatalogo;
  /**
   * Entidad federativa donde se ubica una institución nacional
   * @type {BaseCatalogoLegado}
   * @memberof Institucion
   */
  entidad?: BaseCatalogoLegado;
  /**
   * Municipio donde se ubica una institución nacional
   * @type {BaseCatalogoLegado}
   * @memberof Institucion
   */
  municipio?: BaseCatalogoLegado;
  /**
   * Descripción del primer nivel de sector de una institución
   * @type {BaseCatalogo}
   * @memberof Institucion
   */
  nivelUno?: BaseCatalogo;
  /**
   * Descripción del segundo nivel de sector o ámbito de una institución
   * @type {BaseCatalogo}
   * @memberof Institucion
   */
  nivelDos?: BaseCatalogo;
}

export class Institucion implements IInstitucion {
  constructor(
    public id?: number,
    public clave?: string,
    public nombre?: string,
    public tipo?: BaseCatalogo,
    public pais?: BaseCatalogo,
    public entidad?: BaseCatalogoLegado,
    public municipio?: BaseCatalogoLegado,
    public nivelUno?: BaseCatalogo,
    public nivelDos?: BaseCatalogo
  ) {
    this.id = this.id ? this.id : null;
    this.clave = this.clave ? this.clave : null;
    this.nombre = this.nombre ? this.nombre : null;
    this.tipo = this.tipo ? this.tipo : null;
    this.pais = this.pais ? this.pais : null;
    this.entidad = this.entidad ? this.entidad : null;
    this.municipio = this.municipio ? this.municipio : null;
    this.nivelUno = this.nivelUno ? this.nivelUno : null;
    this.nivelDos = this.nivelDos ? this.nivelDos : null;
  }
}

/**
 * Objeto utilizado por todos los campos provenientes de catálogos
 * @export
 * @interface BaseCatalogo
 */
export interface BaseCatalogo {
  /**
   * Identificador único
   * @type {string}
   * @memberof BaseCatalogo
   */
  id: string;
  /**
   * Nombre o descripción del campo
   * @type {string}
   * @memberof BaseCatalogo
   */
  nombre: string;
}

/**
 * Objeto utilizado para catálogos con clave MIIC
 * @export
 * @interface BaseCatalogoLegado
 */
export interface BaseCatalogoLegado {
  /**
   * Clave
   * @type {string}
   * @memberof BaseCatalogoLegado
   */
  clave: string;
  /**
   * Nombre
   * @type {string}
   * @memberof BaseCatalogoLegado
   */
  nombre: string;
}
